import { lazy, Suspense, useEffect, useMemo, useRef, useState, MouseEvent } from "react";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import './InputBox.scss'
import {
    MaterialReactTable,
    // createRow,
    type MRT_ColumnDef,
    MRT_ColumnFiltersState,
    MRT_DensityState,
    type MRT_Row,
    MRT_SortingState,
    type MRT_TableOptions,
    MRT_VisibilityState,
    useMaterialReactTable,
} from "material-react-table";
import { Box, Button, IconButton, Menu, MenuItem, TextField, Tooltip } from "@mui/material";
import {
    QueryClient,
    QueryClientProvider,
    useMutation,
    useQuery,
    useQueryClient,
} from "@tanstack/react-query";


import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Accordion from "react-bootstrap/Accordion";
import Table from "react-bootstrap/Table";
import { Container, Row } from "reactstrap";

import { toast } from "react-toastify";
import { User } from "./interface";
import { backendbaseUrl } from "../../../Utils/baseUrl";
import axiosInstance from "../../../Utils/axiosInstance";
import { showDeleteConfirmModal } from "../../../Components/ConfirmModal";

const CompanyUserList = () => {
    const [validationErrors, setValidationErrors] = useState<
        Record<string, string | undefined>
    >({});
    const isFirstRender = useRef(true);
    const [filterModes, setFilterModes] = useState<
        { mode: string; id: string; value: unknown }[]
    >([]);

    const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
        [],
    );
    const [columnVisibility, setColumnVisibility] = useState<MRT_VisibilityState>(
        {},
    );
    const [density, setDensity] = useState<MRT_DensityState>('comfortable');
    const [globalFilter, setGlobalFilter] = useState<string | undefined>(
        undefined,
    );
    const [showGlobalFilter, setShowGlobalFilter] = useState(true);
    const [showColumnFilters, setShowColumnFilters] = useState(true);
    const [sorting, setSorting] = useState<MRT_SortingState>([]);
    const [brokerName, SetBrokerName] = useState(null)
    const [inputBackgroundColour, setInputBackgroundColour] = useState("")
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 15, //set different default page size by initializing the state here
    });



    const addButtonRef = useRef<HTMLButtonElement | null>(null);
    const [showRowResizing, setShowRowResizing] = useState<boolean>(true)
    const [totalCount, setTotalCount] = useState(0);
    useEffect(() => {
        //do something when the pagination state changes
    }, [pagination]);
    console.log("pagination :", pagination)
    console.log("columnFilters :", columnFilters)
    console.log("showColumnFilters :", showColumnFilters)
    console.log("sorting :", sorting)
    console.log("showGlobalFilter :", showGlobalFilter)

    console.log("density :", density)
    console.log("globalFilter :", globalFilter)


    useEffect(() => {
        const columnFilters = sessionStorage.getItem('mrt_columnFilters_table_1');
        const columnVisibility = sessionStorage.getItem(
            'mrt_columnVisibility_table_1',
        );
        const density = sessionStorage.getItem('mrt_density_table_1');
        const globalFilter = sessionStorage.getItem('mrt_globalFilter_table_1');
        const showGlobalFilter = sessionStorage.getItem(
            'mrt_showGlobalFilter_table_1',
        );
        const showColumnFilters = sessionStorage.getItem(
            'mrt_showColumnFilters_table_1',
        );
        const sorting = sessionStorage.getItem('mrt_sorting_table_1');

        if (columnFilters) {
            setColumnFilters(JSON.parse(columnFilters));
        }
        if (columnVisibility) {
            setColumnVisibility(JSON.parse(columnVisibility));
        }
        if (density) {
            setDensity(JSON.parse(density));
        }
        if (globalFilter) {
            setGlobalFilter(JSON.parse(globalFilter) || undefined);
        }
        if (showGlobalFilter) {
            setShowGlobalFilter(JSON.parse(showGlobalFilter));
        }
        if (showColumnFilters) {
            setShowColumnFilters(JSON.parse(showColumnFilters));
        }
        if (sorting) {
            setSorting(JSON.parse(sorting));
        }
        isFirstRender.current = false;
    }, []);

    //save states to local storage
    useEffect(() => {
        if (isFirstRender.current) return;
        sessionStorage.setItem(
            'mrt_columnFilters_table_1',
            JSON.stringify(columnFilters),
        );
    }, [columnFilters]);
    //save states to local storage
    useEffect(() => {
        if (isFirstRender.current) return;
        sessionStorage.setItem(
            'mrt_columnFilters_table_1',
            JSON.stringify(columnFilters),
        );

        console.log("columnFilters", "columnFilters---------------", columnFilters)
    }, [columnFilters]);

    useEffect(() => {
        if (isFirstRender.current) return;
        sessionStorage.setItem(
            'mrt_columnVisibility_table_1',
            JSON.stringify(columnVisibility),
        );
    }, [columnVisibility]);

    useEffect(() => {
        if (isFirstRender.current) return;
        sessionStorage.setItem('mrt_density_table_1', JSON.stringify(density));
    }, [density]);

    useEffect(() => {
        if (isFirstRender.current) return;
        sessionStorage.setItem(
            'mrt_globalFilter_table_1',
            JSON.stringify(globalFilter ?? ''),
        );
    }, [globalFilter]);

    useEffect(() => {
        if (isFirstRender.current) return;
        sessionStorage.setItem(
            'mrt_showGlobalFilter_table_1',
            JSON.stringify(showGlobalFilter),
        );
    }, [showGlobalFilter]);

    useEffect(() => {
        if (isFirstRender.current) return;
        sessionStorage.setItem(
            'mrt_showColumnFilters_table_1',
            JSON.stringify(showColumnFilters),
        );
    }, [showColumnFilters]);

    useEffect(() => {
        if (isFirstRender.current) return;
        sessionStorage.setItem('mrt_sorting_table_1', JSON.stringify(sorting));
    }, [sorting]);


    const columns = useMemo<MRT_ColumnDef<User>[]>(
        () => [
            // {
            //   accessorKey: "id",
            //   header: "Id",
            //   enableEditing: false,

            //   // minSize: 40,
            //   // maxSize: 100,
            // },
            {
                accessorKey: "name",
                header: "Name",

                //  size: "auto",
                // minSize: 100,
                // maxSize: 200,
                muiEditTextFieldProps: {
                    required: true,
                    error: !!validationErrors?.name,
                    helperText: validationErrors?.name,
                    //remove any previous validation errors when user focuses on the input
                    onFocus: () =>
                        setValidationErrors({
                            ...validationErrors,
                            name: undefined,
                        }),
                    //optionally add validation checking for onBlur or onChange
                },
            },

            {
                accessorKey: "email",
                header: "Email",

                //  size: "auto",
                // minSize: 100,
                // maxSize: 200,
                muiEditTextFieldProps: {
                    required: true,
                    error: !!validationErrors?.email,
                    helperText: validationErrors?.email,
                    //remove any previous validation errors when user focuses on the input
                    onFocus: () =>
                        setValidationErrors({
                            ...validationErrors,
                            email: undefined,
                        }),
                    //optionally add validation checking for onBlur or onChange
                },
            },

            {
                accessorKey: "last_login",
                header: "Last Login",
                Cell: ({ row }) => (row.original.last_login ? row.original.last_login : '-'),
                //  size: "auto",
                // minSize: 100,
                // maxSize: 200,
                enableColumnFilter: false,
                muiEditTextFieldProps: {
                    required: true,
                    error: !!validationErrors?.last_login,
                    helperText: validationErrors?.last_login,
                    //remove any previous validation errors when user focuses on the input
                    onFocus: () =>
                        setValidationErrors({
                            ...validationErrors,
                            last_login: undefined,
                        }),
                    //optionally add validation checking for onBlur or onChange
                },
            },

            {
                accessorKey: "phone_number",
                header: "Phone Number",
                Cell: ({ row }) => (row.original.phone_number ? row.original.phone_number : '-'),
                //  size: "auto",
                // minSize: 100,
                // maxSize: 200,
                enableColumnFilter: false,
                muiEditTextFieldProps: {
                    required: true,
                    error: !!validationErrors?.phone_number,
                    helperText: validationErrors?.phone_number,
                    //remove any previous validation errors when user focuses on the input
                    onFocus: () =>
                        setValidationErrors({
                            ...validationErrors,
                            phone_number: undefined,
                        }),
                    //optionally add validation checking for onBlur or onChange
                },
            },
            {
                accessorKey: "user_group",
                header: "Assigned  Group",
                enableColumnFilter: false,
                Cell: ({ row }) => (row.original.user_group ? row.original.user_group : '-'),

                //  size: "auto",
                // minSize: 100,
                // maxSize: 200,
                muiEditTextFieldProps: {
                    required: true,
                    error: !!validationErrors?.user_group,
                    helperText: validationErrors?.user_group,
                    //remove any previous validation errors when user focuses on the input
                    onFocus: () =>
                        setValidationErrors({
                            ...validationErrors,
                            user_group: undefined,
                        }),
                    //optionally add validation checking for onBlur or onChange
                },
            },




            // {
            //   accessorKey: "state",
            //   header: "State",

            //   filterVariant: "multi-select",
            //   filterSelectOptions: usStateList,
            //   editVariant: "select",
            //   editSelectOptions: usStates,

            //   muiEditTextFieldProps: {
            //     select: true,
            //     error: !!validationErrors?.state,
            //     helperText: validationErrors?.state,
            //   },
            // },
        ],
        [validationErrors]
    );

    //call CREATE hook
    const { mutateAsync: createUser, isPending: isCreatingUser } =
        useCreateUser();
    //call READ hook
    const {
        data,
        isError: isLoadingUsersError,
        isFetching: isFetchingUsers,
        isLoading: isLoadingUsers,
    } = useGetUsers(filterModes, pagination, setTotalCount, sorting);
    //call UPDATE hook
    const { mutateAsync: updateUser, isPending: isUpdatingUser } =
        useUpdateUser();
    //call DELETE hook
    const { mutateAsync: deleteUser, isPending: isDeletingUser } =
        useDeleteUser();

    //CREATE action
    const handleCreateUser: MRT_TableOptions<User>["onCreatingRowSave"] = async ({
        values,
        table,
    }) => {
        const newValidationErrors = validateUser(values);
        if (Object.values(newValidationErrors).some((error) => error)) {
            setValidationErrors(newValidationErrors);
            return;
        }
        setValidationErrors({});
    };

    //UPDATE action
    const handleSaveUser: MRT_TableOptions<User>["onEditingRowSave"] = async ({
        values,
        table,
    }) => {
        const newValidationErrors = validateUser(values);
        if (Object.values(newValidationErrors).some((error) => error)) {
            setValidationErrors(newValidationErrors);
            return;
        }
        setValidationErrors({});
        await updateUser(values);
        table.setEditingRow(null); //exit editing mode
    };

    //DELETE action
    const openDeleteConfirmModal = (row: MRT_Row<User>) => {
        showDeleteConfirmModal({
            title: "Delete User",
            content: `Are you sure you want to delete this user?`,
            onOk: () => {
                deleteUser(row.original.id);
            },
        });
    };

    console.log("hello")
    const handleCopyRow = (row: any) => {
        if (!row) return;
        const rowData = row.original; // Get the row data
        let textToCopy = JSON.stringify(rowData, null, 2); // Convert to formatted JSON
         if (navigator?.clipboard?.writeText) {
    navigator.clipboard.writeText(textToCopy).catch((err) => {
      console.error("Clipboard write failed:", err);
    });
  } else {
    const textarea = document.createElement("textarea");
    textarea.value = textToCopy;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
  }// Copy to clipboard

        let jsonData;

        try {
            jsonData = JSON.parse(textToCopy);
            SetBrokerName(jsonData.name);
            window.scrollTo({ top: 0, behavior: "smooth" });
            toast.success("copied and pasted successfully")
            setInputBackgroundColour("#83bf6e26");
            setTimeout(() => {
                setInputBackgroundColour(""); // Then set it again
            }, 2400);
        } catch (error) {
            console.error("Invalid JSON. Pasted as a string:", textToCopy);
            jsonData = { rawText: textToCopy }; // Fallback if not valid JSON
        }

    };

    interface ContextMenuPosition {
        mouseX: number;
        mouseY: number;
    }

    const [contextMenu, setContextMenu] = useState<ContextMenuPosition | null>(null);

    // Function to handle right-click and open the menu
    const handleContextMenu = (event: MouseEvent<HTMLDivElement>) => {
        event.preventDefault();
        setContextMenu(
            contextMenu === null
                ? { mouseX: event.clientX + 2, mouseY: event.clientY - 6 }
                : null
        );
    };

    // Function to handle menu close
    const handleClose = () => {
        setContextMenu(null);
    };

    // Function to handle Paste action
    const handlePaste = async () => {
        try {
            const text = await navigator.clipboard.readText();
            let jsonData;

            try {
                jsonData = JSON.parse(text);
                SetBrokerName(jsonData.name);
                window.scrollTo({ top: 0, behavior: "smooth" });
                toast.success("copied and pasted successfully")
                setInputBackgroundColour("#83bf6e26");
                setTimeout(() => {
                    setInputBackgroundColour(""); // Then set it again
                }, 2400);
            } catch (error) {
                console.error("Invalid JSON. Pasted as a string:", text);
                jsonData = { rawText: text }; // Fallback if not valid JSON
            }

            // Here, you can use jsonData further as needed

        } catch (err) {
            console.error("Failed to read clipboard contents:", err);
        }

        handleClose();
    };

    // Function to handle Mark action
    const handleResizing = () => {
        setShowRowResizing(!showRowResizing)
        handleClose();
    };

    const handleExportRows = (e: any) => {
        console.log(e, "djh")
    }


    const table = useMaterialReactTable({
        columns,

        enableStickyHeader: false,
        enableStickyFooter: false,
        enableClickToCopy: true,
        enableRowNumbers: true,
        enableColumnActions: true,
        enableColumnDragging: true,
        enableGlobalFilter: true,
        enableGrouping: true,
        enableHiding: true,
        enableSorting: true,
        enableColumnPinning: true,
        onPaginationChange: setPagination,
        onColumnFiltersChange: setColumnFilters,
        onColumnVisibilityChange: setColumnVisibility,
        onDensityChange: setDensity,
        onGlobalFilterChange: setGlobalFilter,
        onShowColumnFiltersChange: setShowColumnFilters,
        onShowGlobalFilterChange: setShowGlobalFilter,
        onSortingChange: setSorting,
        manualSorting: true,
        manualPagination: true,
        // enableRowSelection: true,
        layoutMode: 'grid',
        enableColumnResizing: showRowResizing,
        rowCount: totalCount,
        manualFiltering: true,
        data: data?.results || [],
        enableDensityToggle: false,
        createDisplayMode: "row", // ('modal', and 'custom' are also available)
        // editDisplayMode: "row", // ('modal', 'cell', 'table', and 'custom' are also available)
        // enableEditing: true,
        enableColumnOrdering: true, // ✅ Enables column drag-and-drop
        enableRowOrdering: false, // ✅ Enables row drag-and-drop
        getRowId: (row) => row.id,
        enableColumnFilterModes: true, //enable changing filter mode for all columns unless explicitly disabled in a column def
        initialState: { showColumnFilters: true }, //show filters by default
        filterFns: {
            customFilterFn: (row, id, filterValue) => {
                return row.getValue(id) === filterValue;
            },
        },


        defaultDisplayColumn: {
            enableResizing: true, //turn on some features that are usually off for all display columns
        },
        displayColumnDefOptions: {
            'mrt-row-actions': {
                size: 100, //set custom width
                muiTableHeadCellProps: {
                    align: 'center', //change head cell props
                },
            },
            'mrt-row-numbers': {
                enableColumnDragging: true,
                enableColumnOrdering: true, //turn on some features that are usually off
                enableResizing: true,
                muiTableHeadCellProps: {
                    sx: {
                        fontSize: '1.2rem',
                    },
                },
            },
            'mrt-row-select': {
                enableColumnActions: true,
                enableHiding: true,
                size: 100,
            },
        },

        renderTopToolbarCustomActions: ({ table }) => (
            <Box
                sx={{
                    display: 'flex',
                    gap: '16px',
                    padding: '8px',
                    flexWrap: 'wrap',
                }}
            >
                <Button
                    //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)

                    startIcon={<FileDownloadIcon />}
                >

                    Export All Data
                </Button>
                {/* <Button
                    disabled={table.getPrePaginationRowModel().rows.length === 0}
                    //export all rows, including from the next page, (still respects filtering and sorting)

                    startIcon={<FileDownloadIcon />}
                >
                    Export All Rows
                </Button>
                <Button
                    disabled={table.getRowModel().rows.length === 0}
                    //export all rows as seen on the screen (respects pagination, sorting, filtering, etc.)

                    startIcon={<FileDownloadIcon />}
                >
                    Export Page Rows
                </Button> */}
                <Button
                    disabled={
                        !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
                    }
                    //only export selected rows
                    onClick={() => handleExportRows(table.getSelectedRowModel().rows)}
                    startIcon={<FileDownloadIcon />}
                >
                    Export Selected Rows
                </Button>
            </Box>
        ),

        // muiTableProps: {
        //   sx: {
        //     border: '1px solid rgba(81, 81, 81, .5)',
        //     caption: {
        //       captionSide: 'top',
        //     },
        //   },
        // },
        muiTableHeadCellProps: {
            sx: {
                border: '1px solid #e0e0e087',
                fontStyle: 'italic',
                fontWeight: 'normal',
            },
        },

        muiTablePaperProps: {
            elevation: 0,
            sx: {
                borderRadius: "0",
                border: "0",
            },
        },
        localization: {
            filterCustomFilterFn: "Custom Filter Fn",
        } as any,

        muiToolbarAlertBannerProps: isLoadingUsersError
            ? {
                color: "error",
                children: "Error loading data",
            }
            : undefined,
        muiTableContainerProps: {
            sx: {
                minHeight: "400px",
            },
        },





        state: {
            sorting,
            columnFilters,
            pagination,
            isLoading: isLoadingUsers,
            isSaving: isCreatingUser || isUpdatingUser || isDeletingUser,
            showAlertBanner: isLoadingUsersError,
            showProgressBars: isFetchingUsers,
            showColumnFilters: true,
        },
    });



    const transformedFilters = columnFilters.map((filter) => ({
        ...filter,
        mode: table.getColumn(filter.id)?.getFilterFn()?.name || "contains",
    }));

    useEffect(() => {
        const transformedFilters = columnFilters.map((filter) => ({
            ...filter,
            mode: table.getColumn(filter.id)?.getFilterFn()?.name || "contains",
        }));

        setFilterModes(transformedFilters);
    }, [columnFilters, table]);
    console.log(transformedFilters, "--------------transformedFilters")
    const someEventHandler = (event: any) => {
        console.info("rows :", table.getRowModel().rows); //example - get access to all page rows in the table
        console.info("row model :", table.getSelectedRowModel()); //example - get access to all selected rows in the table
        console.info("row model :", table.getState().sorting); //example - get access to the current sorting state without having to manage it yourself
    }
    return (
        <div className="page-body">
            <Container fluid>
                <Row>
                    <div>

                        <div className="table-ad">

                            <div className="table-ad__wrapper" onContextMenu={handleContextMenu}>
                                <MaterialReactTable table={table} />

                                {/* Context Menu */}
                                <Menu
                                    open={contextMenu !== null}
                                    onClose={handleClose}
                                    anchorReference="anchorPosition"
                                    anchorPosition={
                                        contextMenu !== null
                                            ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                                            : undefined
                                    }
                                >
                                    <MenuItem onClick={handlePaste}>Paste</MenuItem>
                                    <MenuItem onClick={handleResizing}>{showRowResizing ? "Disable Resizing" : "enable Resizing"}</MenuItem>
                                </Menu>
                            </div>;

                        </div>
                    </div>
                </Row>
            </Container>
        </div>
    );
};

//CREATE hook (post new user to api)
function useCreateUser() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (user: User) => {
            //send api update request here
            await new Promise((resolve) => setTimeout(resolve, 1000)); //fake api call
            return Promise.resolve();
        },
        //client side optimistic update
        onMutate: (newUserInfo: User) => {
            queryClient.setQueryData(
                ["users"],
                (prevUsers: any) =>
                    [
                        ...prevUsers,
                        {
                            ...newUserInfo,
                            id: (Math.random() + 1).toString(36).substring(7),
                        },
                    ] as User[]
            );
        },
        // onSettled: () => queryClient.invalidateQueries({ queryKey: ['users'] }), //refetch users after mutation, disabled for demo
    });
}

//READ hook (get users from api)
function useGetUsers(
    filterModes: { mode: string; id: string; value: unknown }[],
    pagination: { pageIndex: number; pageSize: number },
    setTotalCount: any,
    sorting: any
) {
    return useQuery<{ results: User[]; totalCount: number }>({ // ✅ Correct return type
        queryKey: ["users", filterModes, pagination, sorting], // Ensure proper re-fetching
        queryFn: async () => {
            let url = `${backendbaseUrl}/company/users/lists?page=${pagination.pageIndex + 1}&page_size=${pagination.pageSize}`;

            if (filterModes.length > 0) {
                const queryParams = filterModes
                    .map((e) => `fieldName_${e.id}=${e.value}_${e.mode}`)
                    .join("&");

                url += `&${queryParams}`;
            }

            if (sorting.length > 0) {
                const sortParams = sorting
                console.log(sortParams)
            }
            else {
                console.log("sortParams")
            }

            const response = await axiosInstance.get(url);
            setTotalCount(response.data.count)
            return {
                results: response.data.results as User[],
                totalCount: response.data.count as number,
            };
        },
        refetchOnWindowFocus: false,
    });
}



//UPDATE hook (put user in api)
function useUpdateUser() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (user: User) => {
            //send api update request here
            await new Promise((resolve) => setTimeout(resolve, 1000)); //fake api call
            return Promise.resolve();
        },
        //client side optimistic update
        onMutate: (newUserInfo: User) => {
            queryClient.setQueryData(["users"], (prevUsers: any) =>
                prevUsers?.map((prevUser: User) =>
                    prevUser.id === newUserInfo.id ? newUserInfo : prevUser
                )
            );
        },
        // onSettled: () => queryClient.invalidateQueries({ queryKey: ['users'] }), //refetch users after mutation, disabled for demo
    });
}

//DELETE hook (delete user in api)
function useDeleteUser() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (userId: string) => {
            //send api update request here
            await new Promise((resolve) => setTimeout(resolve, 1000)); //fake api call
            return Promise.resolve();
        },
        //client side optimistic update
        onMutate: (userId: string) => {
            queryClient.setQueryData(["users"], (prevUsers: any) =>
                prevUsers?.filter((user: User) => user.id !== userId)
            );
        },
        // onSettled: () => queryClient.invalidateQueries({ queryKey: ['users'] }), //refetch users after mutation, disabled for demo
    });
}

//react query setup in App.tsx
const ReactQueryDevtoolsProduction = lazy(() =>
    import("@tanstack/react-query-devtools/build/modern/production.js").then(
        (d) => ({
            default: d.ReactQueryDevtools,
        })
    )
);

const queryClient = new QueryClient();

export default function App() {
    return (
        <QueryClientProvider client={queryClient}>
            <CompanyUserList />
            {/* <Suspense fallback={null}>
                <ReactQueryDevtoolsProduction />
            </Suspense> */}
        </QueryClientProvider>
    );
}

const validateRequired = (value: string) => !!value.length;
const validateEmail = (email: string) =>
    !!email.length &&
    email
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );

function validateUser(user: User) {
    return {
        // brokerName: !validateRequired(user.name)
        //   ? "First Name is Required"
        //   : "",
        // name: !validateRequired(user.name) ? "Last Name is Required" : "",
        // email: !validateEmail(user.email) ? "Incorrect Email Format" : "",
    };
}
